module.exports = __webpack_public_path__ + "img/20211017_092702.35a62afd.jpg";